import { Link } from 'react-router-dom';

export default function FinalCTA() {
  const ctas = [
    {
      title: 'Shop New Arrivals',
      description: 'Explore the latest drops',
      link: '/new-arrivals',
      icon: 'ri-shopping-bag-3-line'
    },
    {
      title: 'Explore the Brand',
      description: 'Browse all collections',
      link: '/shop',
      icon: 'ri-store-2-line'
    },
    {
      title: 'Contact BillPlay',
      description: 'Get in touch with us',
      link: '#contact',
      icon: 'ri-customer-service-2-line'
    }
  ];

  return (
    <section className="py-32 px-8 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] tracking-tight mb-8">
            What's Next?
          </h2>

          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Ready to make a move? Here's where to go.
          </p>
        </div>

        {/* CTA Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {ctas.map((cta, index) => (
            <Link
              key={index}
              to={cta.link}
              className="bg-[#181818] border border-[#333333] rounded-2xl p-10 text-center hover:border-white hover:scale-105 transition-all duration-300 group"
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className={`${cta.icon} text-5xl text-white group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              
              <h3 className="text-2xl font-black text-white mb-3">
                {cta.title}
              </h3>
              
              <p className="text-base text-gray-400 mb-6">
                {cta.description}
              </p>

              <div className="inline-flex items-center gap-2 text-sm font-bold text-white">
                <span>GO NOW</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* Final Statement */}
        <div className="text-center">
          <div className="text-7xl md:text-8xl font-black text-white mb-6">
            BILLPLAY
          </div>
          <div className="text-2xl md:text-3xl font-bold text-gray-400 mb-4">
            Culture Over Everything
          </div>
          <div className="text-base text-gray-500">
            Est. 2017 • Kalamazoo, MI
          </div>
        </div>
      </div>
    </section>
  );
}